import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Button, TextField, Grid, MenuItem } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PageTitle from '../../../shared/components/PageTitle';
import { Formik } from 'formik';
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { addSiteAssignment, getArea, getCompany, getEmployee, getRegion, getScheduleSiteData, getSiteAssignmentListById } from '../../api';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    margin: {
        margin: theme.spacing(0),
    },
    withoutLabel: {
        marginTop: theme.spacing(0),
    },
    customToastProgress: {
        backgroundColor: '#F59300',
    },
}));

const UserWrapper = styled.div`
    position: relative;
    .css-sghohy-MuiButtonBase-root-MuiButton-root {
        background-color: #F59300 !important;
    }
    .css-1rwt2y5-MuiButtonBase-root-MuiButton-root {
        border : 1px solid #F59300 !important;
        color : #F59300 !important;
    }

    .wrapperWhite {
        background-color: #ffffff;
        padding: 1.5rem;
        border-radius: 18px;
    }

    .MuiTextField-root {
        width: 100%;
    }

    .card-box{
        position: relative;
        overflow: hidden;
        box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
        border-radius: 0.5rem;
        color: rgba(0, 0, 0, 0.87);
        transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
        background-color: #fff;        
        cursor: pointer;
    }
    .card-indicator {
        position: absolute;
        height: 60%;
        top: 20%;
        width: 0px;
        border-top-right-radius: .75rem;
        border-bottom-right-radius: .75rem;
        left: 0;
        transition: all 0.3s linear;
    }
    .badge-primary {
        color: #fff;
        font-weight: 500;    
    }
    .roleName {
        font-size: 14px;
        font-weight: 500;
    }
    .roleItems { 
        width: 100%;
        height: 100%;
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }
    .roleItems:checked ~ .card-indicator {
        width: 6px;
    }
    .customWidth : {
        width : 100% !important
    }
`;

export default function AddSiteAssignment() {
    const classes = useStyles();
    const { id } = useParams();
    const navigate = useNavigate();
    var [userProfile, setUserProfile] = React.useState();
    var [userName, setUserName] = React.useState("");
    var [userEmail, setUserEmail] = React.useState("");
    var [rows, setRows] = React.useState("");
    var [userData, setUserData] = React.useState([]);
    var [company, setCompany] = React.useState("");
    var [clientList, setClientList] = React.useState([]);
    var [region, setRegion] = React.useState("");
    var [regionList, setRegionList] = React.useState([]);
    var [area, setArea] = React.useState("");
    var [areaList, setAreaList] = React.useState([]);
    var [siteData, setSiteData] = React.useState([]);
    const addSiteAssignmentMsg = () => toast("Site Assignment Added Successfully!", { progressClassName: classes.customToastProgress });
    const updateSiteAssignmentMsg = () => toast("Site Assignment Updated Successfully!", { progressClassName: classes.customToastProgress });
    const errorMessage = () => toast("An error occured, try again later!", { progressClassName: classes.customToastProgress });

    useEffect(() => {
        userProfile = localStorage.getItem("userProfile");
        userProfile = JSON.parse(userProfile);
        setUserProfile(userProfile);
        userName = userProfile.userName;
        setUserName(userName);
        userEmail = userProfile.userEmail;
        setUserEmail(userEmail);

        getUserData();
        fetchCompany();
        fetchSiteAssignment();
    }, [])

    const fetchSiteAssignment = async () => {
        if (id) {
            try {
                const res = await getSiteAssignmentListById(id);
                if (res.data.successCode === 0) {
                    rows = res.data.data
                    setRows(rows);
                    if (rows.clientId != null) {
                        company = rows?.clientId
                        setCompany(company)
                        fetchRegion(company)
                        region = rows?.regionId
                        setRegion(region);
                        fetchArea(region);
                        area = rows?.areaId
                        setArea(area);
                        fetchSiteData(area);
                    }
                }
            } catch (error) {
                errorMessage();
            }
        }
    }

    const getUserData = async () => {
        try {
            const res = await getEmployee();
            if (res.data.successCode === 0) {
                userData = res.data.data
                setUserData(userData);
            }
        } catch (error) {
            errorMessage();
        }
    }

    const fetchCompany = async () => {
        try {
            const res = await getCompany(userEmail);
            if (res.data.successCode === 0) {
                clientList = res.data.data
                setClientList(clientList);
            }
        } catch (error) {
            errorMessage();
        }
    }

    const fetchRegion = async (company) => {
        try {
            const res = await getRegion(company);
            if (res.data.successCode === 0) {
                regionList = res.data.data
                setRegionList(regionList);
            }
        } catch (error) {
            errorMessage();
        }
    }

    const fetchArea = async (regionId) => {
        try {
            const res = await getArea(regionId);
            if (res.data.successCode === 0) {
                areaList = res.data.data
                setAreaList(areaList);
            }
        } catch (error) {
            errorMessage();
        }
    }

    const fetchSiteData = async (area) => {
        try {
            const res = await getScheduleSiteData(userEmail, company, region, area);
            if (res.data.successCode === 0) {
                siteData = res.data.data
                setSiteData(siteData);
            }
        } catch (error) {
            errorMessage();
        }
    }

    const customHandleChange = (e) => {
        company = e.target.value
        setCompany(company);
        fetchRegion(company);
    }

    const handleRegionChange = (e, handleChange) => {
        region = e.target.value
        setRegion(region);
        handleChange(e);
        fetchArea(region);
    }

    const handleAreaChange = (e, handleChange) => {
        area = e.target.value
        setArea(area);
        handleChange(e);
        fetchSiteData(area);
    }

    return (
        <Formik
            enableReinitialize={true}
            initialValues={{
                EmployeeId: rows?.employeeId,
                clientId: rows?.clientId,
                Region: rows?.regionId,
                Area: rows?.areaId,
                SiteId: rows?.siteId,
                TargetCount: rows?.targetCount
            }}
            validate={values => {
                const errors = {}

                if (!values.EmployeeId) {
                    errors.EmployeeId = "Required!"
                }
                if (!company) {
                    errors.clientId = "Required!"
                }
                if (!values.Region) {
                    errors.Region = "Required!"
                }
                if (!values.Area) {
                    errors.Area = "Required!"
                }
                if (!values.SiteId) {
                    errors.SiteId = "Required!"
                }
                if (!values.TargetCount) {
                    errors.TargetCount = "Required!"
                } else if (!Number.isInteger(Number(values.TargetCount)) || Number(values.TargetCount) < 1) {
                    errors.TargetCount = "Must be a whole number greater than 0"
                }

                return errors;
            }}

            const handleMouseDownPwd={(event) => {
                event.preventDefault();
            }}

            onSubmit={async (values, { setSubmitting }) => {
                const postData = {
                    id: id ? id : 0,
                    employeeId: values.EmployeeId,
                    employeeName: userData.find(user => user.id == values.EmployeeId)?.name || "",
                    siteId: values.SiteId,
                    siteName: siteData.find(site => site.id == values.SiteId)?.siteName || "",
                    targetCount: values.TargetCount,
                    userName: userName
                }

                try {
                    const res = await addSiteAssignment(postData);
                    if (res.data.successCode === 0) {
                        { id ? updateSiteAssignmentMsg() : addSiteAssignmentMsg() }
                    } else {
                        errorMessage();
                    }
                    setTimeout(() => { navigate("/assignments") }, 3000);
                } catch (error) {
                    errorMessage();
                    setTimeout(() => { navigate("/assignments") }, 3000);
                }
                setSubmitting(false);
            }}
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting
            }) => (
                <form onSubmit={handleSubmit}>
                    <UserWrapper>
                        <ToastContainer theme='dark' />
                        <Grid container spacing={4} className='d-flex justify-content-center'>
                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <PageTitle>Site Assignment</PageTitle>
                            </Grid>

                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField className="filterDropdown" id="EmployeeId" select label="Select Employee" helperText="" variant="standard" name="EmployeeId" value={values.EmployeeId || ""} onChange={handleChange} onBlur={handleBlur}>
                                    {userData.map(option => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <div className="errMsg" style={{ marginTop: '5px' }}>{errors.EmployeeId && touched.EmployeeId && errors.EmployeeId}</div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField className="filterDropdown" id="clientId" select label="Select Company" helperText="" variant="standard" value={company || ""} name="clientId" onChange={(e) => customHandleChange(e)} onBlur={handleBlur}>
                                    {clientList.map(option => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <div className="errMsg" style={{ marginTop: '5px' }}>{errors.clientId && touched.clientId && errors.clientId}</div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField className="filterDropdown" id="region" select label="Select Region" helperText="" variant="standard" value={values.Region || ""} name="Region" onChange={(e) => handleRegionChange(e, handleChange)} onBlur={handleBlur}>
                                    {regionList.map(option => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <div className="errMsg" style={{ marginTop: '5px' }}>{errors.Region && touched.Region && errors.Region}</div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField className="filterDropdown" id="Area" select label="Select Area" helperText="" variant="standard" name="Area" value={values.Area || ""} onChange={(e) => handleAreaChange(e, handleChange)} onBlur={handleBlur}>
                                    {areaList.map(option => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <div className="errMsg" style={{ marginTop: '5px' }}>{errors.Area && touched.Area && errors.Area}</div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField className="filterDropdown" id="SiteId" select label="Select Site" helperText="" variant="standard" name="SiteId" value={values.SiteId || ""} onChange={handleChange} onBlur={handleBlur}>
                                    {siteData.map(option => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.siteName}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <div className="errMsg" style={{ marginTop: '5px' }}>{errors.SiteId && touched.SiteId && errors.SiteId}</div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField
                                    className="filterDropdown"
                                    id="TargetCount"
                                    label="Target Count"
                                    helperText=""
                                    variant="standard"
                                    name="TargetCount"
                                    type="number"
                                    inputProps={{ min: 1, step: 1 }}
                                    value={values.TargetCount || ""}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        if (val === '' || (/^\d+$/.test(val) && Number(val) >= 0)) {
                                            handleChange(e);
                                        }
                                    }}
                                    onBlur={handleBlur}
                                />
                                <div className="errMsg" style={{ marginTop: '5px' }}>{errors.TargetCount && touched.TargetCount && errors.TargetCount}</div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} className="text-right mt-4">
                                <Button type="button" variant="outlined" color="primary" className="noShadow cancelBtn" onClick={() => navigate("/assignments")}>
                                    Cancel
                                </Button> &nbsp;&nbsp;
                                <Button type="submit" variant="contained" color="primary" className="noShadow addBtn" disabled={isSubmitting}>
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </UserWrapper>
                </form>
            )}
        </Formik>
    );
}